/**
 * Seção do menu a que uma rota pertence (Fase 6, item 25) — vira o *eyebrow* do
 * `PageHeader`: a caption em caixa alta acima do título ("FINANCEIRO", "ADMINISTRAÇÃO")
 * que dá contexto sem gastar altura. Os rótulos são os mesmos dos grupos da `Sidebar`;
 * se um grupo mudar de nome lá, muda aqui — são a mesma coisa vista de dois lugares.
 *
 * Prefixo mais específico primeiro: `/usuarios/saneamento-operador` é Administração
 * antes de qualquer regra mais curta casar.
 */
const SECOES: [prefixo: string, secao: string][] = [
  ['/lgpd', 'Privacidade'],
  ['/usuarios', 'Administração'],
  ['/consultores', 'Administração'],
  ['/tenants', 'Administração'],
  ['/auditoria', 'Administração'],
  ['/conteudo-primeiro-acesso', 'Administração'],
  ['/seguranca', 'Administração'],
  ['/candidaturas', 'Administração'],
  ['/financeiro', 'Financeiro'],
  ['/notas-fiscais', 'Financeiro'],
  ['/campanhas', 'Financeiro'],
  ['/documentos', 'Ferramentas'],
  ['/simulacao', 'Ferramentas'],
  ['/produtos', 'Ferramentas'],
  ['/ia', 'Ferramentas'],
  ['/perfil', 'Conta'],
  ['/notificacoes', 'Conta'],
  ['/dashboard', 'Principal'],
  ['/clientes', 'Principal'],
  ['/reservas', 'Principal'],
  ['/oportunidades', 'Principal'],
  ['/pendencias', 'Principal'],
  ['/renovacoes', 'Principal'],
  ['/agenda', 'Principal'],
  ['/estruturacao', 'Principal'],
  ['/kanban', 'Principal'],
  ['/operacoes', 'Principal'],
]

export const secaoDaRota = (pathname: string): string | null => {
  const hit = SECOES.find(([prefixo]) => pathname === prefixo || pathname.startsWith(`${prefixo}/`))
  return hit ? hit[1] : null
}
